import { ConditionalRuleConfig, ConditionalRuleKind } from './types';

export default (rules: ConditionalRuleConfig[]) => {
  const inBetweenConditionalRules = [
    ConditionalRuleKind.IS_BETWEEN,
    ConditionalRuleKind.IS_NOT_BETWEEN
  ];

  return (
    rules.filter(
      (r: ConditionalRuleConfig) =>
        inBetweenConditionalRules.includes(r.rule as ConditionalRuleKind) &&
        r.value1 >= r.value2
    ).length === 0
  );
};
